import { useContext } from "react";
import type { ExpressCheckoutProviderType } from "../providers/ExpressCheckoutProvider";
import { ExpressCheckoutContext } from "../providers/ExpressCheckoutProvider";

export const useExpressCheckoutContext = (): ExpressCheckoutProviderType => {
  return useContext(ExpressCheckoutContext);
};
